import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito algún equipo especial?',
    a: 'No. Solo tu cama y dos almohadas. Sin colchoneta, sin bandas, sin aparatos.'
  }, {
    q: '¿Cuánto tiempo hasta ver resultados?',
    a: "La mayoría de personas nota diferencia desde el primer 'descenso de comando' correcto. El protocolo completo muestra resultados acumulativos en 3–7 días."
  }, {
    q: '¿Es seguro si tengo hernia discal diagnosticada?',
    a: "El protocolo está diseñado específicamente para hernias y protrusiones en L4-L5 y L5-S1. Trabaja a favor de tu biología, no en contra. El manual incluye la sección 'Red Flags' para casos específicos."
  }, {
    q: '¿Qué pasa si el dolor es demasiado fuerte para moverme?',
    a: "El manual incluye una sección de intensidad graduada. Hay variaciones para días 'buenos' y para días de crisis aguda. Y siempre con criterios claros de cuándo llamar al médico."
  }, {
    q: '¿Esto reemplaza a mi fisioterapeuta o médico?',
    a: 'No. Es complementario. Es lo que haces los 7 días de la semana entre consultas — o cuando el dolor llega a las 2am y no hay nadie a quien llamar.'
  }, {
    q: '¿Cómo accedo al manual?',
    a: 'Inmediatamente después de la compra recibes acceso al PDF descargable. Funciona en teléfono, tablet o computadora.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-white py-24 px-4 border-t border-slate-200" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-12 text-center" data-id="element-49">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-50">
          {faqs.map((faq, idx) => <div key={idx} className="border border-slate-200 rounded-xl overflow-hidden transition-all duration-200" data-id="element-51">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-6 bg-slate-50 hover:bg-slate-100 text-left transition-colors" data-id="element-52">
                <span className="font-bold text-lg text-slate-900 pr-8" data-id="element-53">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-slate-500 flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-54" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-55">
                <div className="p-6 bg-white text-slate-600 text-lg leading-relaxed border-t border-slate-100" data-id="element-56">
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}